import { FilterQueryInterface } from '../interfaces/filter-query.interface';

export class FilterQueryModel implements FilterQueryInterface {
  /**
   * Company search value.
   */
  public search? = '';

  /**
   * Company order by value.
   */
  public orderBy? = '';

  /**
   * Company order sort value.
   */
  public orderSort?: '' | 'asc' | 'desc' = '';

  /**
   * Whether to take into account user rights.
   */
  public forCurrentUser?: boolean;

  /**
   * Company columns to get.
   */
  public columns?: string[];

  /**
   * Whether to include groups.
   */
  public withGroup?: boolean;

  /**
   * Create an instance of FilterQuery.
   *
   * @param jsonData - The json data
   */
  constructor(jsonData: FilterQueryInterface) {
    if (jsonData) {
      this.search = jsonData.search || this.search;
      switch (jsonData.orderBy) {
        case 'name':
          this.orderBy = 'entreprises_nom';
          break;
        case 'quickName':
          this.orderBy = 'quickName';
          break;
        case 'site':
          this.orderBy = 'entreprises_http';
          break;
        default:
          this.orderBy = '';
      }
      this.orderSort = jsonData.orderSort || this.orderSort;
      this.forCurrentUser = jsonData.forCurrentUser;
      this.columns = jsonData.columns || [];
      this.withGroup = jsonData.withGroup;
    }
  }
}
